module.exports = __webpack_public_path__ + "static/media/bg-page5bcb776070304264bbe3853991ee7a63.webp";